var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.146599 29.980017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#61DAFB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.16,7.6667182 -0.17,-0.06 0.17,-0.21 a 3.69,3.69 0 0 0 1.26,-2.72 4.93,4.93 0 0 0 -5.06,-4.88999998 h -7 V 15.906718 h 7.71 a 4.76,4.76 0 0 0 5.07,-5 3.38,3.38 0 0 0 -1.98,-3.2399998 z m -7,-4.43 h 2.83 a 1.43,1.43 0 0 1 1.46,1.48 1.41,1.41 0 0 1 -1.39,1.48 h -2.9 v -3 z m 4.7,8.7699998 a 1.35,1.35 0 0 1 -1.08,0.49 H 13.16 V 9.3867182 h 3.55 a 1.47,1.47 0 0 1 1.46,1.5699998 1.7,1.7 0 0 1 -0.31,1.05 z",
    fill: "#393939",
    id: "path2",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.42,26.186718 H 0 v 4 h 13.42 z",
    fill: "#393939",
    id: "path18",
    style: {
      fill: "#ffffff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.76a948a55efb2345d8bccd75cd95fb2f.svg";
export { ForwardRef as ReactComponent };